export default __webpack_public_path__ + "static/media/04-entrada-general.aa490d38.png";